module.exports = __webpack_public_path__ + "img/1alipay.559544e1.png";